import Vue from 'vue';
import Vuex from 'vuex';
import settings from '@/store/modules/settings.module';
import devices from '@/store/modules/devices.module';
import moves from '@/store/modules/moves.module';
import notifications from '@/store/modules/notifications.module';
import auth from '@/store/modules/auth.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    settings,
    devices,
    moves,
    notifications,
    auth
  }
})
